var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _g2, _path16, _g3, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g4, _path27, _path28, _g5, _path29, _g6, _path30, _path31, _g7, _path32, _g8, _path33, _g9, _path34, _g10, _path35, _g11, _path36, _g12, _path37, _g13, _path38, _g14, _path39, _g15, _path40, _g16, _path41, _g17, _path42, _g18, _path43, _g19, _path44, _g20, _path45, _g21, _path46, _g22, _path47, _g23, _path48, _g24, _path49, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1055,
    height: 704,
    viewBox: "0 0 1055 704",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1055 0H0V704H1055V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M362.765 563.767C324.52 552.402 287.708 537.628 255.824 517.267C118.096 429.316 148.37 225.587 256.446 126.596C290.336 95.5543 334.245 73.8947 380.355 70.0554C431.961 65.7585 485.986 81.9671 524.828 116.687C560.121 148.234 580.851 191.521 626.759 210.216C680.005 231.9 739.057 223.407 794.866 229.831C904.566 242.457 976.255 338.669 952.025 448.456C923.943 575.695 807.101 604.015 693.846 608.447C628.183 611.017 562.52 604.423 497.87 593.246C454.636 585.773 407.71 577.124 362.765 563.767Z",
    fill: "#FFF9F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.258 410.236C229.644 415.17 221.286 416.744 214.265 414.188C207.243 411.633 201.847 405.053 200.711 397.662C199.374 388.966 203.072 378.515 196.931 372.22C193.845 369.057 188.939 367.97 186.324 364.408C184.128 361.416 184.08 357.412 184.121 353.701C184.193 347.109 184.266 340.518 184.339 333.927C181.409 330.269 175.497 330.489 171.998 327.371C168.538 324.287 167.787 319.252 167.166 314.656C165.333 301.079 162.766 287.602 159.481 274.302C169.75 277.323 179.915 280.598 189.649 285.053C195.082 287.539 200.761 290.573 203.487 295.893C206.23 301.247 205.352 307.629 205.268 313.645C205.242 315.588 205.319 317.596 206.14 319.357C208.254 323.896 214.074 324.941 218.412 327.437C223.204 330.196 226.546 335.338 227.121 340.841C227.643 345.836 226.021 350.933 226.964 355.866C229.054 366.801 242.145 371.849 247.376 381.675C252.845 391.948 243.997 402.555 235.258 410.236Z",
    fill: "#E3C192"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M262.204 507.955C262.026 507.955 261.868 507.827 261.836 507.645C259.777 495.706 252.577 463.429 240.071 426.725C230.892 399.787 220.263 374.326 208.479 351.049C193.751 321.958 177.17 296.218 159.193 274.54C159.061 274.381 159.083 274.146 159.242 274.014C159.401 273.882 159.636 273.904 159.768 274.063C177.782 295.784 194.396 321.575 209.149 350.718C220.949 374.028 231.592 399.524 240.783 426.497C253.303 463.244 260.511 495.562 262.573 507.518C262.608 507.721 262.472 507.915 262.268 507.95C262.247 507.954 262.225 507.955 262.204 507.955Z",
    fill: "#1C056D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0918 379.408C76.6211 382.249 78.1161 386.834 79.9106 390.996C81.7052 395.159 84.4394 399.508 88.8412 400.576C93.6144 401.733 98.6274 398.578 103.42 399.65C107.302 400.518 110.054 403.934 112.105 407.345C114.156 410.756 115.939 414.506 119.107 416.913C124.025 420.651 130.853 420.167 136.97 419.321C143.086 418.476 149.744 417.541 155.079 420.653C161.57 424.439 163.99 433.06 170.435 436.926C173.176 438.57 176.413 439.191 179.6 439.428C189.095 440.134 198.803 437.581 206.724 432.293C206.268 423.624 203.255 414.254 197.812 407.496C192.37 400.737 184.193 396.04 175.533 395.579C172.77 395.432 169.976 395.701 167.247 395.246C155.778 393.335 149.818 380.008 139.19 375.289C134.675 373.285 129.425 372.991 124.715 374.48C120.106 375.938 115.99 379.027 111.183 379.538C106.487 380.037 101.95 377.998 97.4036 376.719C88.6829 374.265 81.6137 376.332 73.0918 379.408Z",
    fill: "#E3C192"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M258.988 504.89C258.822 504.89 258.67 504.778 258.627 504.609C253.167 483.246 240.949 462.777 223.294 445.415C208.122 430.496 188.639 417.579 165.384 407.023C140.362 395.664 111.497 387.051 74.5452 379.919C74.3423 379.879 74.2097 379.683 74.2491 379.48C74.2885 379.277 74.4854 379.146 74.6869 379.184C111.698 386.328 140.616 394.958 165.693 406.341C189.028 416.934 208.584 429.9 223.818 444.881C241.57 462.339 253.858 482.928 259.351 504.423C259.402 504.623 259.281 504.826 259.081 504.878C259.05 504.886 259.019 504.89 258.988 504.89Z",
    fill: "#1C056D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M273.692 379.027C268.239 380.081 262.352 378.602 258.043 375.096C253.734 371.591 251.084 366.124 251 360.567C250.936 356.344 252.266 352.234 253.716 348.269C254.213 346.913 254.733 345.496 254.553 344.062C254.411 342.925 253.837 341.89 253.212 340.929C250.864 337.316 247.591 334.176 246.353 330.048C244.156 322.721 249.045 314.832 247.513 307.336C246.979 304.725 245.692 302.338 244.775 299.835C241.544 291.022 243.236 280.575 249.082 273.234C257.314 276.54 262.685 285.325 262.767 294.202C262.808 298.628 261.594 303.315 263.474 307.321C264.597 309.716 266.679 311.494 268.628 313.281C272.042 316.411 275.337 319.998 276.545 324.472C278.442 331.502 274.811 339.258 277.165 346.148C279.501 352.985 287.109 357.052 289.176 363.975C289.729 365.829 289.844 367.796 289.688 369.725C289.447 372.692 288.472 375.755 286.239 377.722C282.763 380.785 278.239 378.149 273.692 379.027Z",
    fill: "#E3C192"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M276.786 506.731C276.594 506.731 276.431 506.584 276.414 506.388C274.799 487.395 275.242 467.956 275.67 449.157C276.263 423.153 276.875 396.263 272.017 370.345C269.505 356.941 265.488 343.604 261.603 330.707C256.199 312.764 250.611 294.211 249.014 275.245C248.997 275.039 249.149 274.858 249.355 274.841C249.557 274.824 249.741 274.976 249.759 275.183C251.349 294.07 256.926 312.586 262.319 330.491C266.209 343.407 270.232 356.764 272.752 370.207C277.625 396.202 277.011 423.132 276.418 449.174C275.99 467.954 275.547 487.372 277.159 506.325C277.177 506.531 277.024 506.712 276.818 506.729C276.808 506.73 276.797 506.731 276.786 506.731Z",
    fill: "#1C056D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.658 626.327C235.658 626.327 201.118 509.502 206.68 506.41C212.242 503.318 348.591 503.195 348.591 503.195C348.591 503.195 332.955 626.064 328.614 626.327C324.272 626.589 247.156 626.86 235.658 626.327Z",
    fill: "#1B3D9E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 206,
    y: 503,
    width: 143,
    height: 124
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M235.658 626.327C235.658 626.327 201.118 509.502 206.68 506.41C212.242 503.318 348.591 503.195 348.591 503.195C348.591 503.195 332.955 626.064 328.614 626.327C324.272 626.589 247.156 626.86 235.658 626.327Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.32 494.159C269.32 494.159 229.432 545.167 231.698 546.528C233.965 547.889 346.018 571.028 345.971 569.667C345.925 568.306 357.366 503.195 357.366 503.195L269.32 494.159Z",
    fill: "#1C056D"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M597.093 525.99H499.53V608.98H597.093V525.99Z",
    fill: "#804E00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M629.259 626.633H469.72C465.67 626.633 462.386 623.347 462.386 619.293V616.321C462.386 612.267 465.67 608.98 469.72 608.98H629.259C633.309 608.98 636.592 612.267 636.592 616.321V619.293C636.592 623.347 633.309 626.633 629.259 626.633Z",
    fill: "#F39C12"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M303.178 236.562C303.385 236.149 303.804 235.891 304.265 235.888C323.941 235.755 775.929 232.745 795.952 235.892C803.846 237.134 801.884 537.938 795.952 549.429C791.59 557.881 309.207 550.449 303.603 549.429C296.693 548.172 293.271 256.323 303.178 236.562Z",
    fill: "#F39C12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M315.074 250.399C315.074 250.399 313.527 507.236 319.713 507.938C325.9 508.64 776.706 511.447 780.573 507.938C784.439 504.429 785.985 248.294 780.573 248.294C775.16 248.294 315.074 250.399 315.074 250.399Z",
    fill: "#D4DFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 314,
    y: 248,
    width: 470,
    height: 262
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M314.172 250.399C314.172 250.399 312.625 507.236 318.811 507.938C324.998 508.64 775.804 511.447 779.671 507.938C783.537 504.429 785.083 248.294 779.671 248.294C774.258 248.294 314.172 250.399 314.172 250.399Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M610.251 242.467L435.053 514.73H305.552L314.172 250.399L610.251 242.467Z",
    fill: "#F39C12"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 385,
    y: 248,
    width: 470,
    height: 262
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M385.172 250.399C385.172 250.399 383.625 507.236 389.811 507.938C395.998 508.64 846.804 511.447 850.671 507.938C854.537 504.429 856.083 248.294 850.671 248.294C845.258 248.294 385.172 250.399 385.172 250.399Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M476 516.952L644.388 241.007H718.281L556.049 515.508L476 516.952Z",
    fill: "#F39C12"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M740.345 248L587 510L681.989 508.782L784 318.534L781.5 248H740.345Z",
    fill: "#F39C12"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M552.869 544.752C558.919 542.243 561.792 535.301 559.286 529.245C556.78 523.189 549.844 520.313 543.794 522.822C537.743 525.33 534.87 532.273 537.377 538.329C539.883 544.385 546.819 547.26 552.869 544.752Z",
    fill: "#804E00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M436.477 361.368C437.059 358.652 438.197 356.589 439.895 355.182C441.59 353.776 443.457 353.048 445.493 352.998C447.53 352.95 449.468 353.558 451.31 354.818C453.151 356.08 454.46 358.02 455.237 360.64C455.332 366.949 455.382 373.184 455.382 379.345C455.382 385.509 455.478 391.695 455.673 397.905C459.938 397.905 464.083 397.857 468.107 397.759C472.129 397.664 475.983 397.614 479.668 397.614C482.286 398.391 484.225 399.629 485.485 401.325C486.744 403.025 487.351 404.796 487.303 406.639C487.253 408.483 486.526 410.182 485.122 411.733C483.715 413.287 481.654 414.354 478.941 414.936C475.16 414.936 471.379 414.961 467.598 415.009C463.817 415.059 460.036 415.034 456.255 414.936C456.448 419.79 456.568 425.053 456.619 430.73C456.666 436.407 456.739 441.672 456.837 446.524C456.641 449.726 455.601 452.105 453.71 453.656C451.819 455.21 449.711 455.985 447.384 455.985C445.057 455.985 442.851 455.185 440.767 453.584C438.681 451.982 437.445 449.631 437.058 446.524C436.961 441.574 437.033 436.359 437.277 430.875C437.518 425.394 437.543 420.176 437.35 415.227C433.18 415.132 428.697 414.913 423.898 414.572C419.098 414.233 414.445 413.531 409.937 412.462C405.428 411.395 401.283 409.892 397.503 407.949C393.721 406.009 390.668 403.437 388.341 400.234C386.207 397.227 384.996 393.975 384.705 390.481C384.414 386.988 384.753 383.399 385.723 379.709C386.691 376.023 388.145 372.286 390.086 368.501C392.024 364.716 394.133 361.077 396.412 357.584C398.689 354.09 400.968 350.815 403.247 347.758C405.524 344.701 407.537 342.008 409.282 339.679C413.158 334.439 417.135 329.344 421.207 324.395C425.279 319.446 429.351 314.449 433.423 309.402C435.554 307.655 437.761 306.759 440.04 306.709C442.317 306.661 444.28 307.219 445.93 308.383C447.577 309.547 448.716 311.199 449.347 313.332C449.976 315.468 449.806 317.844 448.838 320.465C445.541 324.54 441.662 329.176 437.204 334.366C432.744 339.559 428.356 344.992 424.043 350.669C419.728 356.346 415.801 362.121 412.263 367.991C408.723 373.864 406.228 379.564 404.774 385.095C404.192 387.037 404.41 388.711 405.428 390.117C406.446 391.525 407.948 392.689 409.936 393.611C411.922 394.534 414.226 395.285 416.844 395.867C419.462 396.449 422.055 396.886 424.624 397.177C427.192 397.468 429.569 397.687 431.75 397.832C433.932 397.978 435.604 398.1 436.768 398.196C436.572 392.082 436.477 385.946 436.477 379.782C436.477 373.621 436.477 367.482 436.477 361.368Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M507.009 428.473C505.748 424.302 504.487 419.084 503.228 412.825C501.967 406.566 501.022 399.797 500.392 392.519C499.76 385.241 499.542 377.769 499.738 370.102C499.931 362.437 500.778 355.109 502.282 348.122C503.784 341.135 506.086 334.78 509.19 329.053C512.292 323.328 516.412 318.816 521.552 315.516C527.951 311.44 534.542 308.528 541.33 306.782C548.115 305.035 554.757 304.357 561.253 304.744C567.747 305.133 573.928 306.516 579.795 308.892C585.66 311.271 590.798 314.496 595.21 318.572C599.621 322.648 603.159 327.55 605.826 333.274C608.492 339.001 609.921 345.406 610.116 352.489C610.212 359.185 610.455 366.343 610.844 373.96C611.23 381.579 611.255 389.221 610.916 396.886C610.575 404.553 609.582 411.952 607.935 419.085C606.285 426.217 603.572 432.647 599.791 438.372C596.592 443.225 592.301 447.155 586.921 450.162C581.54 453.171 575.723 455.282 569.469 456.494C563.216 457.707 556.793 458.023 550.2 457.441C543.606 456.858 537.426 455.38 531.658 453.001C525.889 450.624 520.799 447.397 516.388 443.321C511.976 439.245 508.849 434.296 507.009 428.473ZM531.296 332.255C528.773 334.198 526.519 337.036 524.533 340.771C522.545 344.508 521.406 348.463 521.116 352.634C520.727 358.457 520.339 364.352 519.952 370.321C519.564 376.289 519.418 382.184 519.516 388.006C519.611 393.829 520.098 399.556 520.97 405.183C521.842 410.812 523.442 416.198 525.769 421.341C527.223 424.739 529.38 427.6 532.241 429.929C535.099 432.258 538.298 434.055 541.839 435.315C545.376 436.577 549.133 437.28 553.109 437.425C557.083 437.571 560.962 437.184 564.743 436.261C568.524 435.34 572.088 433.859 575.432 431.821C578.777 429.784 581.613 427.163 583.939 423.961C585.587 421.923 586.921 419.084 587.939 415.445C588.957 411.806 589.706 407.755 590.193 403.291C590.677 398.828 590.968 394.218 591.066 389.462C591.161 384.708 591.161 380.196 591.066 375.924C590.968 371.655 590.87 367.846 590.775 364.497C590.677 361.15 590.63 358.7 590.63 357.146C590.725 352.488 589.975 348.146 588.375 344.118C586.776 340.092 584.569 336.574 581.758 333.565C578.945 330.558 575.625 328.131 571.796 326.286C567.965 324.444 563.846 323.375 559.435 323.084C555.023 322.793 550.419 323.375 545.62 324.831C540.821 326.287 536.045 328.762 531.296 332.255Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M678.758 361.368C679.339 358.652 680.478 356.589 682.175 355.182C683.87 353.776 685.738 353.048 687.774 352.998C689.81 352.95 691.748 353.558 693.591 354.818C695.432 356.08 696.741 358.02 697.518 360.64C697.613 366.949 697.663 373.184 697.663 379.345C697.663 385.509 697.758 391.695 697.954 397.905C702.219 397.905 706.363 397.857 710.388 397.759C714.41 397.664 718.264 397.614 721.949 397.614C724.567 398.391 726.505 399.629 727.766 401.325C729.025 403.025 729.632 404.796 729.584 406.639C729.534 408.483 728.807 410.182 727.403 411.733C725.996 413.287 723.935 414.354 721.222 414.936C717.441 414.936 713.66 414.961 709.879 415.009C706.097 415.059 702.316 415.034 698.536 414.936C698.729 419.79 698.849 425.053 698.899 430.73C698.947 436.407 699.019 441.672 699.117 446.524C698.922 449.726 697.881 452.105 695.991 453.656C694.1 455.21 691.991 455.985 689.664 455.985C687.338 455.985 685.131 455.185 683.048 453.584C680.962 451.982 679.726 449.631 679.339 446.524C679.241 441.574 679.314 436.359 679.558 430.875C679.798 425.394 679.823 420.176 679.63 415.227C675.461 415.132 670.978 414.913 666.178 414.572C661.379 414.233 656.726 413.531 652.218 412.462C647.709 411.395 643.564 409.892 639.784 407.949C636.003 406.009 632.949 403.437 630.622 400.234C628.488 397.227 627.277 393.975 626.986 390.481C626.695 386.988 627.034 383.399 628.004 379.709C628.972 376.023 630.427 372.286 632.367 368.501C634.305 364.716 636.414 361.077 638.693 357.584C640.97 354.09 643.249 350.815 645.528 347.758C647.805 344.701 649.818 342.008 651.563 339.679C655.44 334.439 659.416 329.344 663.488 324.395C667.56 319.446 671.632 314.449 675.704 309.402C677.835 307.655 680.042 306.759 682.321 306.709C684.598 306.661 686.561 307.219 688.211 308.383C689.858 309.547 690.997 311.199 691.628 313.332C692.258 315.468 692.087 317.844 691.12 320.465C687.822 324.54 683.944 329.176 679.485 334.366C675.025 339.559 670.637 344.992 666.324 350.669C662.009 356.346 658.082 362.121 654.545 367.991C651.004 373.864 648.509 379.564 647.055 385.095C646.473 387.037 646.691 388.711 647.709 390.117C648.727 391.525 650.229 392.689 652.218 393.611C654.203 394.534 656.507 395.285 659.125 395.867C661.743 396.449 664.336 396.886 666.906 397.177C669.473 397.468 671.85 397.687 674.031 397.832C676.213 397.978 677.885 398.1 679.049 398.196C678.853 392.082 678.757 385.946 678.757 379.782C678.758 373.621 678.758 367.482 678.758 361.368Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M408.109 551.428L361.483 420.217L373.323 422.122C373.991 422.229 374.549 422.69 374.781 423.328L421.444 551.552C421.454 551.581 421.433 551.611 421.402 551.611L408.109 551.428Z",
    fill: "#1B3D9E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M258.211 557.001C260.18 556.652 356.918 419.212 361.483 420.217C366.047 421.223 419.205 582.746 417.23 582.432C415.255 582.118 253.319 557.869 258.211 557.001Z",
    fill: "#FC476A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M346.442 534.772C345.691 535.446 344.929 535.883 344.155 536.082C343.38 536.282 342.638 536.275 341.929 536.062C341.22 535.851 340.577 535.451 340.001 534.864C339.426 534.277 338.99 533.513 338.694 532.574C339.164 526.799 339.525 520.932 339.777 514.974C340.029 509.016 340.35 503.092 340.74 497.205C341.128 491.318 341.69 485.521 342.423 479.812C343.154 474.103 344.238 468.611 345.669 463.336C345.785 462.908 346.18 462.525 346.854 462.186C347.527 461.847 348.345 461.605 349.309 461.461C350.273 461.316 351.322 461.26 352.457 461.291C353.59 461.323 354.683 461.46 355.735 461.701C356.785 461.943 357.719 462.302 358.535 462.778C359.351 463.255 359.946 463.871 360.322 464.624C360.932 465.465 361.297 466.911 361.417 468.963C361.537 471.015 361.491 473.486 361.281 476.377C361.069 479.269 360.684 482.48 360.124 486.009C359.564 489.539 358.901 493.165 358.138 496.885C357.373 500.606 356.533 504.339 355.617 508.085C354.7 511.831 353.73 515.37 352.707 518.702C351.682 522.034 350.657 525.069 349.628 527.805C348.599 530.542 347.604 532.751 346.645 534.432C346.637 534.481 346.569 534.595 346.442 534.772ZM336.428 556.679C335.369 555.865 334.515 554.925 333.868 553.855C333.22 552.785 332.847 551.697 332.751 550.591C332.654 549.485 332.886 548.407 333.45 547.356C334.013 546.305 334.951 545.388 336.264 544.606C338.073 543.505 339.885 543.087 341.701 543.351C343.516 543.614 344.913 544.717 345.894 546.657C346.815 548.34 347.257 550.158 347.22 552.111C347.182 554.062 346.333 555.75 344.671 557.171C343.457 558.267 342.085 558.718 340.556 558.524C339.027 558.33 337.65 557.715 336.428 556.679Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M882.193 626.108H765.132C762.786 626.108 760.884 624.204 760.884 621.856V484.99C760.884 482.642 762.786 480.738 765.132 480.738H882.193C884.539 480.738 886.441 482.642 886.441 484.99V621.856C886.442 624.204 884.539 626.108 882.193 626.108Z",
    fill: "#1B3D9E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 760,
    y: 480,
    width: 127,
    height: 147
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M882.193 626.108H765.132C762.786 626.108 760.884 624.204 760.884 621.856V484.99C760.884 482.642 762.786 480.738 765.132 480.738H882.193C884.539 480.738 886.441 482.642 886.441 484.99V621.856C886.442 624.204 884.539 626.108 882.193 626.108Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M889.976 501.322C889.976 501.322 840.799 570.632 751.798 589.815V632.238H893.076C893.076 632.238 896.765 503.805 889.976 501.322Z",
    fill: "#1C056D"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M794.073 480.738C794.073 480.738 792.407 361.069 794.628 359.679C796.849 358.289 813.789 356.899 815.178 360.234C816.566 363.57 815.178 480.737 815.178 480.737H794.073V480.738Z",
    fill: "#FC476A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 793,
    y: 358,
    width: 23,
    height: 123
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M794.073 480.738C794.073 480.738 792.407 361.069 794.628 359.679C796.849 358.289 813.789 356.899 815.178 360.234C816.566 363.57 815.178 480.737 815.178 480.737H794.073V480.738Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M808.599 376.749V483.099H800.668V376.963L808.599 376.749Z",
    fill: "#D40221"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 793,
    y: 358,
    width: 23,
    height: 123
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M794.073 480.738C794.073 480.738 792.407 361.069 794.628 359.679C796.849 358.289 813.789 356.899 815.178 360.234C816.566 363.57 815.178 480.737 815.178 480.737H794.073V480.738Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M790.18 381.346C790.18 381.346 814.827 379.474 818.263 381.193C818.263 381.193 818.091 356.604 816.717 356.088C815.343 355.572 791.807 355.439 791.292 358.171C790.777 360.903 790.18 381.346 790.18 381.346Z",
    fill: "#D4DFFF"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "#D4DFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M840.49 300.344H823.663V487.072H840.49V300.344Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 320.057H827.601V322.212H833.781V320.057Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 329.977H827.601V332.132H833.781V329.977Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 339.898H827.601V342.053H833.781V339.898Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 349.819H827.601V351.974H833.781V349.819Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 359.74H827.601V361.895H833.781V359.74Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 369.661H827.601V371.815H833.781V369.661Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 379.581H827.601V381.736H833.781V379.581Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 389.502H827.601V391.657H833.781V389.502Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 399.423H827.601V401.577H833.781V399.423Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 409.343H827.601V411.498H833.781V409.343Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 419.264H827.601V421.419H833.781V419.264Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 429.184H827.601V431.339H833.781V429.184Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 439.105H827.601V441.26H833.781V439.105Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 449.026H827.601V451.181H833.781V449.026Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 458.947H827.601V461.102H833.781V458.947Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.781 468.868H827.601V471.022H833.781V468.868Z",
    fill: "#6880E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_89_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 827,
    y: 306,
    width: 50,
    height: 175
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M876.652 480.738H827.601V308.02C827.601 307.294 828.189 306.706 828.915 306.706H875.339C876.065 306.706 876.653 307.294 876.653 308.02V480.738H876.652Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_89_2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M866.042 300.139C852.431 311.811 847.657 332.685 854.841 349.121C858.26 356.942 864.103 363.919 865.2 372.386C866.263 380.6 862.654 388.589 859.8 396.363C856.987 404.024 854.822 412.117 855.393 420.259C856.327 433.575 864.487 446.032 863.154 459.313C861.874 472.069 851.961 483.176 852.532 495.983C852.696 495.983 852.361 496.547 852.524 496.547H884.392L884.377 299.323L888.297 299.362L866.042 300.139Z",
    fill: "#6880E4"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M971.945 628.129H166.802C165.976 628.129 165.307 627.459 165.307 626.633C165.307 625.806 165.976 625.137 166.802 625.137H971.945C972.771 625.137 973.44 625.806 973.44 626.633C973.44 627.459 972.771 628.129 971.945 628.129Z",
    fill: "#1C056D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1055,
    height: 704,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.3850677d9a74eb89f854d6c5d10f09e0.svg";
export { ForwardRef as ReactComponent };